/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "UnitNotificationPreferencesValues": {
                    "fields": {
                      "notificationTypeValue": {
                        "type": "squareup.bbfrontend.service.v1.UnitNotificationPreferencesValues.NotificationTypeValue",
                        "id": 1,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "NotificationTypeValue": {
                        "fields": {
                          "value": {
                            "type": "bool",
                            "id": 1,
                            "keyType": "string"
                          }
                        }
                      }
                    }
                  },
                  "UnitNotificationPreferencesConfig": {
                    "fields": {
                      "notificationTypeConfig": {
                        "type": "squareup.bbfrontend.service.v1.UnitNotificationPreferencesConfig.NotificationTypeConfig",
                        "id": 1,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "NotificationTypeConfig": {
                        "fields": {
                          "isEnabled": {
                            "type": "bool",
                            "id": 1,
                            "keyType": "string"
                          }
                        }
                      }
                    }
                  },
                  "UnitNotificationPreferences": {
                    "fields": {
                      "notificationTypeOrder": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "notificationChannelOrder": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "unitNotificationPreferencesValues": {
                        "type": "squareup.bbfrontend.service.v1.UnitNotificationPreferencesValues",
                        "id": 3,
                        "rule": "optional"
                      },
                      "unitNotificationPreferencesConfig": {
                        "type": "squareup.bbfrontend.service.v1.UnitNotificationPreferencesConfig",
                        "id": 4,
                        "rule": "optional"
                      },
                      "email": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "employmentToken": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "notificationTypeTexts": {
                        "type": "string",
                        "id": 8,
                        "keyType": "string"
                      },
                      "notificationChannelTexts": {
                        "type": "string",
                        "id": 9,
                        "keyType": "string"
                      },
                      "emailLabel": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "phoneNumberLabel": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferencesValues && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferencesValues?.nested?.NotificationTypeValue && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferencesConfig && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferencesConfig?.nested?.NotificationTypeConfig && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferences) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UnitNotificationPreferencesValues @ squareup/bbfrontend/v1/unit_notification_preferences.proto at 11:1
 */
export const UnitNotificationPreferencesValues = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferencesValues');
fixType(UnitNotificationPreferencesValues);
Builder.createAndAttachToType(UnitNotificationPreferencesValues);
/**
 * SOURCE NotificationTypeValue @ squareup/bbfrontend/v1/unit_notification_preferences.proto at 15:3
 */
UnitNotificationPreferencesValues.NotificationTypeValue = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferencesValues.NotificationTypeValue');
fixType(UnitNotificationPreferencesValues.NotificationTypeValue);
Builder.createAndAttachToType(UnitNotificationPreferencesValues.NotificationTypeValue);
/**
 * SOURCE UnitNotificationPreferencesConfig @ squareup/bbfrontend/v1/unit_notification_preferences.proto at 22:1
 */
export const UnitNotificationPreferencesConfig = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferencesConfig');
fixType(UnitNotificationPreferencesConfig);
Builder.createAndAttachToType(UnitNotificationPreferencesConfig);
/**
 * SOURCE NotificationTypeConfig @ squareup/bbfrontend/v1/unit_notification_preferences.proto at 26:3
 */
UnitNotificationPreferencesConfig.NotificationTypeConfig = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferencesConfig.NotificationTypeConfig');
fixType(UnitNotificationPreferencesConfig.NotificationTypeConfig);
Builder.createAndAttachToType(UnitNotificationPreferencesConfig.NotificationTypeConfig);
/**
 * SOURCE UnitNotificationPreferences @ squareup/bbfrontend/v1/unit_notification_preferences.proto at 33:1
 */
export const UnitNotificationPreferences = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferences');
fixType(UnitNotificationPreferences);
Builder.createAndAttachToType(UnitNotificationPreferences);